
<mat-dialog-content>
  <h1 mat-dialog-title>Add Associated Airports</h1>
  <div class="edit-add-airport__filter">
    <mat-form-field hintLabel="Min. 3 characters to search">
      <input matInput placeholder="Airport Filter" [(ngModel)]="airportFilter">
    </mat-form-field>
    <mat-checkbox [(ngModel)]="searchPrivateAirports">Search Private Airports</mat-checkbox>
  </div>
  <div class="edit-add-airport__table" *ngIf="!isLoading; else spinner">
    <table class="data-block">
      <thead><tr>
        <th class="data-block__label">Airport ID</th>
        <th class="data-block__label">FAA ID</th>
        <th class="data-block__label">ICAO ID</th>
        <th class="data-block__label name">Name</th>
        <th class="data-block__label"></th>
      </tr></thead>
      <tbody>
      <tr *ngFor="let airport of currentPage;">
        <td class="data-block__value">{{ airport.airportId }}</td>
        <td class="data-block__value">{{ airport.faaId     }}</td>
        <td class="data-block__value">{{ airport.icaoId    }}</td>
        <td class="data-block__value name">{{ airport.name      }}</td>
        <td><button mat-button (click)="onAdd(airport)">Add</button></td>
      </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator [length]="searchedAirports ? searchedAirports.length : 0"
                 [pageSize]="pageLength"
                 (page)="doPageEvent($event)">
  </mat-paginator>
  <mat-dialog-actions id="closeButton"><button mat-button (click)="dialogRef.close()">Close</button></mat-dialog-actions>
</mat-dialog-content>
<ng-template #spinner>
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</ng-template>

